export default "__VITE_ASSET__atYOAoi6__"